import React from 'react'
import { Doughnut } from 'react-chartjs-2'

const COLORS = ['#2F6FED', '#1D4FC4', '#12B76A', '#F79009', '#8E44AD']

/**
 * Canvas tooltips clip at the (small) chart canvas edge, cutting off long
 * customer names and the value. Render the tooltip as a DOM element instead,
 * positioned over the page so it can overflow the chart freely. One shared
 * element serves every chart using this handler.
 */
function htmlTooltip (tooltipModel) {
  let el = document.getElementById('dbv2-chart-tooltip')
  if (!el) {
    el = document.createElement('div')
    el.id = 'dbv2-chart-tooltip'
    el.className = 'dbv2-chart-tooltip'
    document.body.appendChild(el)
  }
  if (tooltipModel.opacity === 0) {
    el.style.opacity = 0
    return
  }
  const lines = (tooltipModel.body || []).map((b) => b.lines.join(' '))
  el.textContent = lines.join(' · ')
  const rect = this._chart.canvas.getBoundingClientRect()
  // Center on the caret, but clamp inside the viewport so long names near the
  // page edge stay fully readable.
  let left = rect.left + window.pageXOffset + tooltipModel.caretX - el.offsetWidth / 2
  const minLeft = window.pageXOffset + 8
  const maxLeft = window.pageXOffset + document.documentElement.clientWidth - el.offsetWidth - 8
  left = Math.max(minLeft, Math.min(left, maxLeft))
  el.style.left = `${left}px`
  el.style.top = `${rect.top + window.pageYOffset + tooltipModel.caretY - el.offsetHeight - 10}px`
  el.style.opacity = 1
}

/**
 * US-DB-8/9 — top 5 by active certificate count: pie chart + legend list
 * with its own YTD / All-time toggle (AC-16/AC-17).
 */
export default function TopActivePanel ({ title, data, loading, mode, onModeChange }) {
  let body = null
  if (loading && !data) {
    body = <div className='dbv2-loading'>Memuat…</div>
  } else if (data) {
    const items = data.items || []
    if (items.length === 0) {
      body = <div className='dbv2-empty'>Tidak ada data untuk periode yang dipilih.</div>
    } else {
      const chartData = {
        labels: items.map((i) => i.name || '—'),
        datasets: [{
          data: items.map((i) => i.count),
          backgroundColor: COLORS.slice(0, items.length),
          borderWidth: 1
        }]
      }
      const options = {
        maintainAspectRatio: false,
        legend: { display: false },
        cutoutPercentage: 55,
        tooltips: {
          enabled: false,
          custom: htmlTooltip,
          callbacks: {
            label: (item, chart) => {
              const label = chart.labels[item.index] || '—'
              const value = chart.datasets[item.datasetIndex].data[item.index]
              return `${label}: ${Number(value).toLocaleString('id-ID')}`
            }
          }
        }
      }
      body = (
        <div className='dbv2-top-body'>
          <div className='dbv2-top-chart'>
            <Doughnut data={chartData} options={options} />
          </div>
          <div className='dbv2-top-list'>
            {items.map((item, index) => (
              <div className='dbv2-top-item' key={`${item.name}-${index}`}>
                <span className='dbv2-top-dot' style={{ background: COLORS[index] }} />
                <span className='dbv2-top-name' title={item.name}>{item.name || '—'}</span>
                <span className='dbv2-top-count'>{item.count.toLocaleString('id-ID')}</span>
              </div>
            ))}
          </div>
        </div>
      )
    }
  }

  return (
    <div className='dbv2-card'>
      <p className='dbv2-card-title'>{title}</p>
      <div className='dbv2-toggle-bar'>
        <button
          className={mode === 'ytd' ? 'dbv2-active' : ''}
          onClick={() => onModeChange('ytd')}
        >YTD</button>
        <button
          className={mode === 'all' ? 'dbv2-active' : ''}
          onClick={() => onModeChange('all')}
        >All-time</button>
      </div>
      {body}
    </div>
  )
}
